import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from "@mui/material";
import { grayFontColor } from "../../../../cssUtils/constants";
import typography from "../../../../cssUtils/typography";
import TemplateMessagePreview from "../../../CampaignsV2/TemplateMessagePreview";
import { SAMPLE_OTP_CODE } from "../../otpApi";

const PLACEHOLDER_REGEX = /\{\{\s*(\d+)\s*\}\}/g;

// Rebuilds what Create Template stores as template_preview_json from the template's own record,
// so the shared message preview (security line, expiry footer, Copy code / Autofill button)
// renders it the same way the template list does. {{1}} is the OTP code; the other placeholders
// take the custom value entered in Select OTP Template.
const buildPreviewData = (template, variables) => {
  const templateJson = template?.template_json || {};
  const metaPayload = templateJson.meta_payload || {};
  const bodyInputs = metaPayload.library_template_body_inputs || {};
  const body = templateJson.content || "";

  return {
    template_name: template?.template_name,
    marketingOption: "template-library",
    language: templateJson.languageCode,
    body,
    sampleBodyFields: [...body.matchAll(PLACEHOLDER_REGEX)].map(([, position]) =>
      position === "1"
        ? { type: "otp", value: SAMPLE_OTP_CODE, variable_name: position }
        : { type: "custom", value: variables?.[position] || "", variable_name: position },
    ),
    addSecurityRecommendation: Boolean(bodyInputs.add_security_recommendation),
    codeExpirationMinutes: bodyInputs.code_expiration_minutes || 0,
    otpType: metaPayload.library_template_button_inputs?.[0]?.otp_type || "COPY_CODE",
  };
};

const OtpTemplatePreview = ({ open, onClose, template, variables }) => (
  <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
    <DialogTitle sx={typography.h6}>Template Preview</DialogTitle>
    <DialogContent>
      <Stack spacing={1.5}>
        <Stack direction="row" justifyContent="space-between">
          <Typography sx={typography.bodySmall}>{template?.template_name}</Typography>
          <Typography sx={{ ...typography.bodySmall, color: grayFontColor }}>
            Authentication
          </Typography>
        </Stack>

        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <TemplateMessagePreview templatePreviewData={buildPreviewData(template, variables)} />
        </Box>

        <Typography sx={{ ...typography.bodySmall, color: grayFontColor }}>
          Sample code shown. Custom variables use their entered values.
        </Typography>
      </Stack>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose}>Close</Button>
    </DialogActions>
  </Dialog>
);

export default OtpTemplatePreview;
